import React from 'react';
import PropTypes from 'prop-types';

import {IncludeScript, Loading} from 'Common/Structure';

import StripeForm from '.';
import CardOnFile from '../CardOnFile';

class StripeFormWrapper extends React.Component {
  componentDidMount() {
    if (window.Stripe) {
      this.props.setProcessor({
        obj: window.Stripe(this.props.stripeData.key),
      });
    } else {
      document.querySelector('#stripe-js').addEventListener('load', () =>
        this.props.setProcessor({
          obj: window.Stripe(this.props.stripeData.key),
        }),
      );
    }
  }

  render() {
    return (
      <IncludeScript async id="stripe-js" src="https://js.stripe.com/v3/">
        {this.props.stripe && this.props.stripe.obj ? (
          <div>
            {this.props.cardOnFile && (
              <CardOnFile
                cardsOnFile={[this.props.cardOnFile]}
                onChangeCardSelection={this.props.onChangeCardSelection}
                processorName="Stripe"
                selectedCard={this.props.selectedCard}
              />
            )}

            {this.props.showCreditCard && (
              <StripeForm
                setProcessor={this.props.setProcessor}
                stripe={this.props.stripe}
                updateSubmitButtonEnabled={this.props.updateSubmitButtonEnabled}
              />
            )}
          </div>
        ) : (
          <Loading />
        )}
      </IncludeScript>
    );
  }
}

StripeFormWrapper.defaultProps = {
  cardOnFile: null,
  stripe: {},
};

StripeFormWrapper.propTypes = {
  cardOnFile: PropTypes.shape({
    cardType: PropTypes.string.isRequired,
    externalCustomerId: PropTypes.string.isRequired,
    lastFourDigits: PropTypes.string.isRequired,
  }),
  selectedCard: PropTypes.string.isRequired,
  showCreditCard: PropTypes.bool.isRequired,
  stripe: PropTypes.shape({
    obj: PropTypes.object,
    card: PropTypes.object,
  }),
  stripeData: PropTypes.shape({
    key: PropTypes.string.isRequired,
  }),

  // functions
  onChangeCardSelection: PropTypes.func.isRequired,
  setProcessor: PropTypes.func.isRequired,
  updateSubmitButtonEnabled: PropTypes.func.isRequired,
};

export default StripeFormWrapper;



// WEBPACK FOOTER //
// ./src/components/Payments/PaymentCollection/components/PaymentForm/StripeForm/Wrapper.js